import React from 'react';

interface SearchPaginationProps {
  totalResults: number;
  currentLimit: number;
  onLimitChange: (limit: number) => void;
}

const SearchPagination: React.FC<SearchPaginationProps> = ({
  totalResults,
  currentLimit,
  onLimitChange
}) => {
  const totalPages = Math.ceil(totalResults / currentLimit);
  const currentPage = 1; // For now, we'll assume single page results

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <span className="text-sm text-gray-700">
          Showing {Math.min(currentLimit, totalResults)} of {totalResults} results
        </span>
        
        <div className="flex items-center space-x-2">
          <span className="text-sm text-gray-700">Results per page:</span>
          <select
            value={currentLimit}
            onChange={(e) => onLimitChange(parseInt(e.target.value))}
            className="px-2 py-1 text-sm border border-gray-300 rounded focus:outline-hidden focus:ring-2 focus:ring-blue-500"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-700">
          Page {currentPage} of {totalPages}
        </span>
        
        {/* Future pagination controls can be added here */}
        {totalPages > 1 && (
          <div className="flex space-x-1">
            <button
              disabled
              className="px-3 py-1 text-sm border border-gray-300 rounded bg-gray-100 text-gray-400 cursor-not-allowed"
            >
              Previous
            </button>
            <button
              disabled
              className="px-3 py-1 text-sm border border-gray-300 rounded bg-gray-100 text-gray-400 cursor-not-allowed"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchPagination;
